import { NotClosedOrder } from "src/services/Api/Organization/types";
import { ApiError } from "go-core/api/types";

export interface OrderNotClosedConfig {
	translation: string;
	redirectLink?: string;
	documentType?: NotClosedOrder;
}

export enum ExpandOpenCorrections {
	EXPANDED,
	NOT_EXPANDED,
	INVISIBLE,
}

export interface OrderNotClosedApiError extends ApiError {
	document_types?: NotClosedOrder[];
	documents?: Record<keyof typeof NotClosedOrder, Record<string, any>[]>;
}
